import React from 'react';
import Books from './books';

const BooksContainer = () => (
  <div>
    <Books />
  </div>
);

export default BooksContainer;
